module.exports = __webpack_public_path__ + "img/star_05.eed8166c.png";